module.exports = __webpack_public_path__ + "img/33.6a22498d.png";